import useProductDetail from "@/app/lib/features/productDetail/productDetail.hook";
import { ChevronRight } from "lucide-react";
import { getIcon } from "@/app/utils/getIcon";
import Link from "next/link";
import { trackCampaignView } from "@/app/lib/tracking/interactions";

const CampaignInfo = () => {
  const { product } = useProductDetail();

  if (!product?.campaigns || product.campaigns.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2">
      <p className="uppercase text-[9px] font-bold text-[#999]">
        Ürünün Kampanyaları
      </p>
      {product.campaigns.map((campaign) => {
        const IconComponent = getIcon(campaign.icon);
        
        return (
          <Link
            key={campaign.id}
            href={`/kampanya/${campaign.slug}`}
            onClick={() => trackCampaignView(campaign.id)}
            className="bg-white border p-2 rounded-md flex items-center gap-2 font-medium text-xs transition-all duration-300 ease-in-out hover:border-black hover:shadow-lg"
          >
            <div 
              className="w-8 h-8 flex items-center justify-center rounded-md shrink-0"
              style={{ backgroundColor: campaign.color_hex ? `${campaign.color_hex}15` : '#f5f5f5' }}
            >
              {IconComponent && (
                <IconComponent 
                  size={20} 
                  style={{ color: campaign.color_hex || 'currentColor' }}
                />
              )}
            </div>
            <p className="flex-1 leading-tight">{campaign.name}</p>
            <ChevronRight size={18} className="shrink-0" />
          </Link>
        );
      })}
    </div>
  );
};

export default CampaignInfo;
